import { render, staticRenderFns } from "./EnviarMensaje.vue?vue&type=template&id=7d94baea&"
import script from "./EnviarMensaje.vue?vue&type=script&lang=js&"
export * from "./EnviarMensaje.vue?vue&type=script&lang=js&"
import style0 from "./EnviarMensaje.vue?vue&type=style&index=0&id=7d94baea&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports